import React, { useEffect, useState } from 'react'
import './sharedquotes.scss'
import { DataTable } from '../../CommonComponent'
import { IContainerProps } from './sharedquotesinterface'
import Loader from '../../Loader'
import ExportexcelComp from '../../CommonComponent/ExportExcel';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import partsService from "../../../services/partsservice";
import helperfunctions from '../../../utils/helperfunctions';
import { useSelector } from 'react-redux';
import { selectors as headerSelector } from '../../../state/features/header';
import moment from 'moment';

const SharedQuotes = (props: IContainerProps) => {
    const { sharedNestedQuote } = props;
    const { t } = useTranslation();
    const {
        headercurrentuser,
    }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
        })
    );

    const ExportSharedQuoteColumn = [
        {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Quote_Number),
            field: 'quoteNumber',
            width: 150,
        },
        {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Quote_Name),
            field: 'quoteName',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Label_SC_NoOfParts),
            field: 'totParts',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Label_Comments),
            field: 'comments',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Shared_With),
            field: 'sharedToUserEmail',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Label_ShoppingCart_Shared_Date),
            field: 'createdUTCDateExcel',
            width: 150
        }
    ]

    const ExportSharedQuoteDetailColumn = [
        {
            title: t(RESOURCE.MyK_Grid_Manufacturer),
            field: 'manufacturerName',
            width: 150,
        },
        {
            title: t(RESOURCE.MyK_Grid_Parts_Number),
            field: 'partNumber',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Grid_Description),
            field: 'description',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Grid_Qty),
            field: 'partQty',
            width: 150
        },
        {
            title: t(RESOURCE.MyK_Grid_Machine),
            field: 'machine',
            width: 150
        }
    ]

    const DetailComponent = React.useMemo(() => (props: any) => <DetailComponentCell {...props} />, [])

    const DetailComponentCell = (props: any) => {
        const [detailData, setDetailData] = useState<any>([]);
        useEffect(() => {
            getQuoteShareDetailData();
        }, [])

        const getQuoteShareDetailData = () => {
            partsService.getQuoteShareDetailData(props?.dataItem?.quoteId, headercurrentuser?.eml)
                .then((response: any) => {
                    setDetailData(response ?? []);
                })
                .catch((e: any) => {
                    helperfunctions.showErrorMessage(e);
                });
        }
        const nestedSharedGriddata = detailData?.map((item: any) => ({
            ...item,
            createdDate: new Date(moment(item.createdUTCDate).format("MM/DD/YYYY")),
            viewDateFilter: item.viewedDate ? new Date(moment(item.viewedDate).format("MM/DD/YYYY")) : ""
        }));
        return (
            <DataTable storageKey={"sharedQuotesNested"} enableFiltering={true} data={nestedSharedGriddata} dataColumn={sharedNestedQuote} />
        )
    }
   

    const sharedquotescolumns = props?.sharedquotescolumns?.length ? props?.sharedquotescolumns : []
    const selectedSharedQuoteObject = props?.selectedSharedQuoteObject ?? {};

    
    return (
        <div className='sharedquotesgrid'>
            {props?.isLoading && <Loader />}
            {props.showsharedDetails ? null : <div><DataTable
            storageKey={"sharedQuotesDetails"} enableFiltering={true}
                data={props?.data}
                dataColumn={sharedquotescolumns}
                dataItemKey='quoteId'
                DetailRow={true}
                DetailComponent={DetailComponent} exportRef={props?.gridRef} setMount={props?.setMount}
            />
                {props?.mount?.flag && <ExportexcelComp
                    data={props?.mount?.data?.length ? props?.mount?.data : props?.data ?? []}
                    setMount={props?.setMount}
                    exportColumn={ExportSharedQuoteColumn}
                    ExportFileName='QuoteList_'
                />}
            </div>
            }

            {props.showsharedDetails ? <div className='sharedDetailWrapper'>
                <div className='sharedDetailWrapperHD my-3'>
                    <span className='mr-3'><strong>{t(RESOURCE.MyK_Label_SC_Quote)} #:</strong> {selectedSharedQuoteObject?.quoteNumber}</span>
                    {(selectedSharedQuoteObject?.quoteName ?? "") != "" && <span className='mr-3'><strong>{t(RESOURCE.MyK_Label_ShoppingCart_Title)} :</strong> {selectedSharedQuoteObject?.quoteName}</span>}
                    {(selectedSharedQuoteObject?.fileDisplayName ?? "") != "" && <span className='mr-3'><strong>{t(RESOURCE.MyK_AppNotificationLabel_Attachment)} :</strong> <span className="attachmentLink" onKeyDown={() => { }} onClick={() => props.downloadAttachment(selectedSharedQuoteObject)}> {selectedSharedQuoteObject?.fileDisplayName}</span> </span>}
                </div>
                {props?.isDetailsLoading && <Loader />}
                <div><DataTable
                storageKey={"sharedQuotes"} enableFiltering={true}
                    data={selectedSharedQuoteObject?.quoteList ?? []}
                    dataColumn={props.sharedquotesDetailscolumns}
                    dataItemKey='id'
                    exportRef={props?.gridRef} setMount={props?.setMount}
                />
                    {props?.mount?.flag && <ExportexcelComp
                        data={props?.mount?.data?.length ? props?.mount?.data : selectedSharedQuoteObject?.quoteList ?? []}
                        setMount={props?.setMount}
                        exportColumn={ExportSharedQuoteDetailColumn}
                        ExportFileName='QuoteDetailList_'
                    />}
                </div>
                {
                    ((selectedSharedQuoteObject?.comments??"")!="") &&
                    <div className='sharedDetailWrapperHD my-3'>
                        <span className='my-2'><strong>{t(RESOURCE.MyK_Label_Comments)}:</strong></span>
                            <textarea rows={1} readOnly={true} className='sharedTextarea' onChange={(e) => { props?.onCommentChange(e?.target?.value ?? '') }} value={selectedSharedQuoteObject?.comments}></textarea>
                    </div>
                }
            </div> : null}
        </div>
    )
}

export default SharedQuotes